export default {
	// Config
	apiKey: "AIzaSyDWQwBURtID5yvtUR3irvd_jNn2xfepXG8",
  authDomain: "made-mytrace.firebaseapp.com",
  projectId: "made-mytrace",
  storageBucket: "made-mytrace.firebasestorage.app",
  messagingSenderId: "806704465365",
  appId: "1:806704465365:web:cd8ca4667aed5674bba95c"
};
